/* ============================
  TRUE VIEWERHEIGHT IN CSS
  Here we set a global css variable of --vh with the browsers true vh height.
  This helps on mobile browsers, where it now accounts for the address bar at the top.
============================ */

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* ============================
  AJAX ADD TO CART
============================ */
$(document).ready(function(){
    window.addItem = function(event) {
        event.preventDefault()
        var form = $(event.target).closest("form");
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
           success: function(line_item) {
            $.getJSON("/cart.js", function(cart) {
                if(window.BOLD && window.BOLD.BMS && window.BOLD.BMS.DrawerCart) {
                  BOLD.BMS.DrawerCart.updateCart(cart);
                } 
                BOLD.BMS.DrawerCart.openCart()
              });
          },
           error: function(XMLHttpRequest, textStatus) {
            if ((typeof errorCallback) === 'function') {
                console.log(XMLHttpRequest, textStatus);
            }
            else {
              console.log(XMLHttpRequest, textStatus);
            }
          }
        });
     }

})
